import { isEmpty } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import { FILE_TYPES } from '@/utils'

import render from './render'

const attachRules = {
  [SendingTypes.viber]: {
    categories: [ 'image' ],
    defaultCategory: 'image'
  },
  [SendingTypes.voice]: {
    categories: [ 'audio' ],
    defaultCategory: 'audio'
  },
  [SendingTypes.whatsapp]: {
    categories: [ 'image', 'file' ],
    defaultCategory: 'image'
  }
}

export default {
  name: 'Attach',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    type: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: undefined
    }
  },

  data() {
    return {
      showFileManager: false,
      currentType: undefined
    }
  },

  computed: {
    attachRule() {
      return attachRules?.[this.type]
    },

    typeCategories() {
      return this.attachRule?.categories || []
    },

    activeAttachType() {
      if (!this.attachRule) {
        return
      }

      if (this.type === SendingTypes.voice) {
        return 'audio'
      }

      if (this.type === SendingTypes.whatsapp) {
        if (this.currentType) {
          return this.currentType
        }
        if (!isEmpty(this.value.image)) {
          return 'image'
        }
        if (!isEmpty(this.value.file)) {
          return 'file'
        }

        return this.attachRule.defaultCategory
      }

      return this.attachRule.defaultCategory
    },

    payloadFile() {
      return this.value?.[this.activeAttachType]
    },

    fileManagerTypes() {
      switch (this.type) {
        case SendingTypes.voice: return FILE_TYPES.wav.extensions
        case SendingTypes.viber: return FILE_TYPES.jpg.extensions
        case SendingTypes.whatsapp:
          if (this.activeAttachType === 'image') {
            return FILE_TYPES.jpg.extensions
          }

          return FILE_TYPES.file.extensions

        default: return []
      }
    }
  },

  watch: {
    type() {
      this.showFileManager = false
    },

    value: {
      handler() {
        if (this.type === SendingTypes.whatsapp) {
          if (!isEmpty(this.value.image)) {
            this.currentType = 'image'
          } else if (!isEmpty(this.value.file)) {
            this.currentType = 'file'
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    this.currentType = this.activeAttachType
    this.setFile(this.payloadFile)
  },

  methods: {
    setCurrentType(type) {
      this.currentType = type
      this.showFileManager = true
    },

    setFile(id) {
      if (id) {
        this.$emit('input', {
          id,
          type: this.currentType
        })
        this.showFileManager = false
      }
    },

    clearHandler() {
      this.$emit('input', { type: this.activeAttachType })
    }
  },

  render
}
